import { TwcOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';

import { Headings } from '../../components/headings';
import { FreeForTenUsersText } from '../../components/sub-heading';
import { WelcomeBackText } from '../../components/welcome-back-heading';

export const ExistingUser = () => (
	<TwcOverlayTemplate size="sm">
		<Headings main={<WelcomeBackText />} sub={<FreeForTenUsersText />} />
		<SiteActivation />
	</TwcOverlayTemplate>
);
